module.exports = __webpack_public_path__ + "media/fastweb_volunteers/TFJ_Logo_350x242-0376d511.jpg";